import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const GeexHandymanPageHeader = ({
  page,
  hasLogoImage,
  hasBannerImage,
  hasName,
  hasDescription,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <div
      className={cn('relative text-page-text', {
        'lg:pt-fluid-10': !forceMobile,
      })}
    >
      <HeaderBanner
        media={page?.bannerMedia}
        className="absolute size-full"
        style={{
          WebkitMaskImage: `linear-gradient(to bottom, white 70%, transparent 100%)`,
          maskImage: `linear-gradient(to bottom, white 70%, transparent 100%)`,
        }}
        {...props}
      />

      <div
        className={cn('relative px-fluid-3 bottom-0', {
          'pt-fluid-96 pb-fluid-8 -mb-fluid-4': hasBannerImage,
          'pt-fluid-20 pb-fluid-8': !hasBannerImage,
        })}
      >
        <div className="relative">
          {(hasLogoImage || hasDescription || hasName) && (
            <div
              className="page-header-block ft-widget-wrapper absolute left-0 top-0 size-full border-none!"
              style={{
                maskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNjciIGhlaWdodD0iNDAiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGZpbGw9IiMwMDAiCiAgICBkPSJNMCAuMjI0VjQwaDEyNC4zODlhMTYuNTQ2IDE2LjU0NiAwIDAgMS0xMi45Mi02LjIxbC04LjM4NC0xMC40OTVhMTYuNTU1IDE2LjU1NSAwIDAgMC0xMi45MzgtNi4yMjlIMTYuODQyYTE2LjgzMiAxNi44MzIgMCAwIDEtMTEuOTAzLTQuOTMyQTE2Ljg3IDE2Ljg3IDAgMCAxIDAgLjIyNFpNMjQyLjQ0NyA0MGgxMjQuNDI2Vi4yOTZhMTYuODY4IDE2Ljg2OCAwIDAgMS00LjkzMyAxMS44MzIgMTYuODMgMTYuODMgMCAwIDEtMTEuOTA5IDQuOTM4aC03My4zMDVhMTYuNTQzIDE2LjU0MyAwIDAgMC0xMi45NjUgNi4yMWwtOC4zODUgMTAuNDk1YTE2LjU1NyAxNi41NTcgMCAwIDEtMTIuOTI5IDYuMjNaIiAvPgo8L3N2Zz4K')`,
                maskRepeat: 'no-repeat',
                maskSize: '100%',
                maskPosition: 'center calc(100% + 1px)',
                maskComposite: 'exclude',
                WebkitMaskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNjciIGhlaWdodD0iNDAiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGZpbGw9IiMwMDAiCiAgICBkPSJNMCAuMjI0VjQwaDEyNC4zODlhMTYuNTQ2IDE2LjU0NiAwIDAgMS0xMi45Mi02LjIxbC04LjM4NC0xMC40OTVhMTYuNTU1IDE2LjU1NSAwIDAgMC0xMi45MzgtNi4yMjlIMTYuODQyYTE2LjgzMiAxNi44MzIgMCAwIDEtMTEuOTAzLTQuOTMyQTE2Ljg3IDE2Ljg3IDAgMCAxIDAgLjIyNFpNMjQyLjQ0NyA0MGgxMjQuNDI2Vi4yOTZhMTYuODY4IDE2Ljg2OCAwIDAgMS00LjkzMyAxMS44MzIgMTYuODMgMTYuODMgMCAwIDEtMTEuOTA5IDQuOTM4aC03My4zMDVhMTYuNTQzIDE2LjU0MyAwIDAgMC0xMi45NjUgNi4yMWwtOC4zODUgMTAuNDk1YTE2LjU1NyAxNi41NTcgMCAwIDEtMTIuOTI5IDYuMjNaIiAvPgo8L3N2Zz4K')`,
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskSize: '100%',
                WebkitMaskPosition: 'center calc(100% + 1px)',
                WebkitMaskComposite: 'exclude',
              }}
            />
          )}

          <div
            className={cn(
              'flex flex-col space-y-fluid-2 px-fluid-4 pt-fluid-4 pb-fluid-8 relative',
              {
                'pt-fluid-6!': hasLogoImage,
              },
            )}
          >
            <HeaderLogo
              media={page?.logoMedia}
              {...props}
              className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-fluid-14 rounded-[20px]"
              sizeClassName="size-fluid-20"
              size={80}
            />

            <HeaderName
              name={page?.name}
              {...props}
              className="text-center text-fluid-3xl text-page-heading-text"
            />

            <HeaderDescription
              description={page?.description}
              {...props}
              className="text-center text-fluid-base text-page-body-text"
            />
          </div>
        </div>

        <HeaderSocialIcons
          socialIcons={page?.socialIcons}
          {...props}
          className="w-full pt-fluid-4"
          primaryClassName="p-fluid-4 page-header-primary-button flex-1"
          secondaryClassName="p-fluid-4 page-header-secondary-button"
          showPrimaryLabel
        />
      </div>
    </div>
  )
}
